import Theme11 from './theme11'
import Theme12 from './theme12'

export default function Index(props) {
    console.log(props, 'props in share to media index.js');

    const theme = props?.home?.data?.site?.site_theme

    switch (theme) {
        case 'theme11':
            return <Theme11 {...props} />

        case 'theme12':
            return <Theme12 {...props} />

        default:
            return <Theme11 {...props} />
    }
}
